import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

import {
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Dialog as UiDialog,
} from '@/components/ui/dialog';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import type { ShipmentEmbryo } from '@/services/shipping/types';

import { EmbryoFormValues } from '../recane-embryos-form/schema';
import { RecanePrintWizard } from '../recane-print-wizard';

type RecanePrintWizardDialogProps = {
  visible: boolean;
  onHide: () => void;
  embryos?: ShipmentEmbryo[];
  existingCaneCodes?: string[];
  onSuccess?: (data: EmbryoFormValues) => void;
  onError?: (error: unknown) => void;
  'data-testid'?: string;
};

export const RecanePrintWizardDialog = ({
  visible,
  onHide,
  embryos,
  existingCaneCodes,
  onSuccess,
  onError,
  'data-testid': dataTestId,
}: RecanePrintWizardDialogProps) => {
  const { t } = useTranslation();
  const isBaseUi = useFeatureFlag('recane_print_wizard_prime_to_base_ui');

  if (isBaseUi) {
    return (
      <UiDialog
        open={visible}
        onOpenChange={(open) => {
          if (!open) onHide();
        }}
      >
        <DialogContent
          preflight={false}
          className="z-[2000] md:max-w-[1000px]"
          overlayClassName="z-[2000]"
          data-testid={dataTestId}
        >
          <DialogHeader className="preflight">
            <DialogTitle>{t('embryo.recaneAndPrint')}</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <div onClick={(e) => e.stopPropagation()}>
              <RecanePrintWizard
                embryos={embryos}
                existingCaneCodes={existingCaneCodes}
                onCancel={onHide}
                onSuccess={onSuccess}
                onError={onError}
              />
            </div>
          </DialogBody>
        </DialogContent>
      </UiDialog>
    );
  }

  return (
    <Dialog
      header={t('embryo.recaneAndPrint')}
      visible={visible}
      onHide={onHide}
      modal
      className="w-[1000px] max-w-[95vw]"
      data-testid={dataTestId}
    >
      <div onClick={(e) => e.stopPropagation()}>
        <RecanePrintWizard
          embryos={embryos}
          existingCaneCodes={existingCaneCodes}
          onCancel={onHide}
          onSuccess={onSuccess}
          onError={onError}
        />
      </div>
    </Dialog>
  );
};
